class PushCartOmetria extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.ometriaElement = this.querySelector('#ometria-sidecart-recs')
    this.loadingText = this.querySelector('[data-loading-message]')
    this.container = this.closest('[data-ometriaContainer]')
    this.hasLoaded = false

    if (!this.container) {
      console.warn('Ometria sidecart: container not found')
      return
    }

    // Only initialize on desktop (matching Nosto behavior)
    if (
      (window.innerWidth >= 901 && this.hasAttribute('data-desktop')) ||
      (window.innerWidth < 901 && this.hasAttribute('data-mobile'))
    ) {
      // Watch for drawer opening
      this.setupDrawerObserver()
    }
  }

  setupDrawerObserver () {
    // Watch for when the cart drawer opens
    // The body gets the class 'drw-Drawers-cart' when the cart drawer is open
    if (!this.container) return

    // Watch for body class changes
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          const isCartOpen = document.body.classList.contains(
            'drw-Drawers-cart',
          )

          // Show Ometria drawer when cart is open
          if (isCartOpen) {
            this.container.setAttribute('aria-hidden', 'false')
            if (!this.hasLoaded) {
              this.loadRecommendations()
            }
          } else {
            this.container.setAttribute('aria-hidden', 'true')
          }
        }
      })
    })

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    })

    // Also check if cart drawer is already open
    if (document.body.classList.contains('drw-Drawers-cart')) {
      this.container.setAttribute('aria-hidden', 'false')
      if (!this.hasLoaded) {
        this.loadRecommendations()
      }
    }

    // Also listen for drawer open events as a backup
    if (window.BAO?.eventBus) {
      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.OPEN_DRAWER,
        event => {
          if (event.detail?.key === 'cart' && !this.hasLoaded) {
            this.container.setAttribute('aria-hidden', 'false')
            this.loadRecommendations()
          }
        },
      )
    }
  }

  loadRecommendations () {
    // Prevent loading multiple times
    if (this.hasLoaded) return

    // Check if graphenehc is available
    if (!window.graphenehc?.load) {
      console.warn('GrapheneHC not available for sidecart recommendations')
      return
    }

    // Mark as loading
    this.hasLoaded = true

    // Hide loading text
    if (this.loadingText) {
      this.loadingText.setAttribute('aria-hidden', 'true')
    }

    // Load recommendations using the dedicated sidecart template
    window.graphenehc.load({
      elements: [{ id: 'sidecart_recs', target: '#ometria-sidecart-recs' }],
      // Ensure products data is included so current_element.products is populated
      include: ['products'],
      url: window.location.pathname + window.location.search,
      args: {},
      page_context: {
        currency_id: window.ometriaCurrency || window.Shopify?.currency?.active,
      },
      success: response => {
        // Handle success - section-async elements will load automatically
        setTimeout(() => {
          this.initializeProductCards()
        }, 100)
      },
      error: error => {
        console.warn('Failed to load Ometria sidecart recommendations:', error)
        // Reset hasLoaded so it can try again
        this.hasLoaded = false
      },
    })
  }

  initializeProductCards () {
    // Initialize any product card interactions if needed
    // This can be used to set up quick buy buttons, color swatches, etc.
    const productCards = this.querySelectorAll('.prd-CardAlt_Async')
    productCards.forEach(card => {
      // Add any initialization logic here if needed
    })
  }
}

if (!customElements.get('push-cart-ometria')) {
  customElements.define('push-cart-ometria', PushCartOmetria)
}
